<template>
  <div id="seo-content-accordion-component" class="sokal-modern-styles sokal-px-4">
    <div class="sokal-container">
      <div class="sokal-vertical-space">
        <div class="sokal-space-y-4 hidden-xs hidden-sm"></div>
        <div class="sokal-space-y-4 hidden-xs hidden-sm"></div>
        <div class="sokal-space-y-2 hidden-md hidden-lg"></div>
      </div>
      <div class="sokal-md-grid accordion-flex">
        <div class="seo-content-accordion">
          <div class="title-block-content">
            <p class="super-title">Hometown Dealer</p>
            <h2>Your Trusted Ford Dealership In Raleigh, NC</h2>
            <div class="sokal-space-y-1"></div>
            <p class="sub-title sokal-my-1 sokal-mt-0">
              Hometown Dealer is your go-to Ford dealership for top-quality cars, pickups, SUVs, and commercial vehicles.
            </p>
          </div>
          <div class="accordion-item" data-image="https://d2v1gjawtegg5z.cloudfront.net/uploads/files/001/774/353/original/approved.png?1763656691">
            <button class="accordion-header">
              Shop New Fords & Used Vehicles at Hometown Dealer
            </button>
            <div class="accordion-content">
              <p>
                Whether you're interested in the capable Ford F-150 or the thrilling Ford Mustang, our extensive lineup of <a href="#" class="text-link">new Fords for sale</a> is worth a look. Alternatively, our selection of <a href="#" class="text-link">pre-owned vehicles for sale</a> offers great options for nearly any budget. Plus, each model is thoroughly inspected to ensure it meets our high standards of quality and reliability.
              </p>
              <p>
                You can easily <a href="#" class="text-link">schedule a test drive</a> to experience any of our fantastic new or pre-owned Ford vehicles firsthand. Additionally, we have an in-house finance center at our Ford dealership. Raleigh, NC, drivers know they can turn to us for fair pricing and attractive financing and leasing options
              </p>
            </div>
          </div>
      
          <div class="accordion-item" data-image="https://d2v1gjawtegg5z.cloudfront.net/uploads/files/001/772/677/original/bronco.png?1763584668">
            <button class="accordion-header">Sell or Trade In Your Car to Our Raleigh Dealer</button>
            <div class="accordion-content">
              <p>
                If you're considering <a href="#" class="text-link">selling or trading your car</a>, our Ford dealership in Raleigh, NC, is the perfect place to start. Our expert appraisers provide transparent evaluations and offer competitive trade-in values. We make the process simple and stress-free.
              </p>
              <p>
                By trading in your car with us, you can seamlessly apply its value toward the purchase of a new or pre-owned vehicle from our diverse inventory. Visit us today to get started and discover how easy it is to sell or trade in your car at our Ford dealership.
              </p>
            </div>
          </div>
      
          <div class="accordion-item" data-image="https://d2v1gjawtegg5z.cloudfront.net/uploads/files/001/774/356/original/trade.png?1763656692">
            <button class="accordion-header">Order Genuine Ford Parts Today</button>
            <div class="accordion-content">
              <p>
                As your local Ford parts dealer in Raleigh, NC, you can order OEM components from us to ensure your vehicle maintains optimal performance and reliability. Our <a href="#" class="text-link">Ford parts department</a> offers a comprehensive selection of high-quality parts and accessories designed specifically for Ford models. Whether you require a replacement or want an upgrade, our knowledgeable staff is here to help you find exactly what you need.
              </p>
              <p>
                Visit our website or stop by our Ford parts department to shop or place your order for genuine components. You can stop searching for a "full-service Ford dealer near me ." You have found it. Hometown Dealer looks forward to working with you soon!
              </p>
            </div>
          </div>

          <div class="accordion-item" data-image="https://d2v1gjawtegg5z.cloudfront.net/uploads/files/001/774/354/original/inventory.png?1763656691">
            <button class="accordion-header">Order The Commercial Truck You Want</button>
            <div class="accordion-content">
              <p>
                At Hometown Dealer, we understand that your business relies on having the right commercial vehicle. That's why we offer a selection of customizable Ford commercial trucks and vans to fit your specific needs. When you're looking for a durable, adaptable, and reliable workhorse, turn to our Ford dealership.
              </p>
              <p>
                As a Ford BPN Dealer, we are certified and trained to help you find the ideal commercial vehicle for your business. We use an advanced software called Commercial Vehicle Tools (CVT) to provide tailored recommendations based on your needs. We consider your preferences for payload, cargo space, upfit capabilities, and more, ensuring you get the best vehicle for your operations.
              </p>
            </div>
          </div>

          <div class="cta-btn-block sokal-flex sokal-gap sokal-items-center sokal-my-2 sokal-mb-0">
            <a class="sokal-btn sokal-btn-primary has-border-radius" href="#">
              <div class="sokal-flex sokal-flex-row sokal-items-center sokal-justify-center">
                <span class="sokal-btn-copy">New Vehicle Specials</span>
                <div class="sokal-btn-icon-slot" style="height: 1.6em;"></div>
              </div>
            </a>
            <a class="sokal-link sokal-link-secondary" href="#">
              <div class="sokal-flex sokal-flex-row sokal-gap sokal-items-center sokal-justify-center">
                <span class="sokal-link-copy">Value Your Trade</span>
                <svg xmlns="http://www.w3.org/2000/svg" width="1.13em" height="1.6em" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-arrow-right">
                  <line x1="5" y1="12" x2="19" y2="12"></line>
                  <polyline points="12 5 19 12 12 19"></polyline>
                </svg>
              </div>
            </a>
          </div>
        </div>
      
        <div class="image-area">
          <img id="accordion-image" src="" alt="Accordion image">
        </div>
      </div>
      <div class="sokal-vertical-space">
        <div class="sokal-space-y-4 hidden-xs hidden-sm"></div>
        <div class="sokal-space-y-4 hidden-xs hidden-sm"></div>
        <div class="sokal-space-y-2 hidden-md hidden-lg"></div>
      </div>
    </div>
  </div>
</template>

<script>
  import "../../static/bootstrap-3.3.7-dist/js/bootstrap.min.js";

  export default {
    props: ['images'],
    data() {
      return {
        accordionImages: {
          slot1: imageOne,
          slot2: imageTwo,
          slot3: imageThree,
          slot4: imageFour
        }
      };
    },
    mounted() {
      const items = document.querySelectorAll(".accordion-item");
      const image = document.getElementById("accordion-image");

      items.forEach(item => {
        const header = item.querySelector(".accordion-header");
        const content = item.querySelector(".accordion-content");

        header.addEventListener("click", () => {

          // Remove all active states
          items.forEach(i => {
            i.classList.remove("active");
            i.querySelector(".accordion-content").style.maxHeight = null;
          });

          // Open selected panel
          item.classList.add("active");
          content.style.maxHeight = '125px'; 
          content.style.overflowY = 'scroll';

          // Update image
          const src = item.getAttribute("data-image");

          // Remove previous fade-in
          image.classList.remove("fade-in");

          // Small delay ensures animation retriggers
          setTimeout(() => {
            image.src = src;
            image.classList.add("fade-in");
          }, 10);
        });
      });

      // Initialize first item open and image visible
      const first = items[0];
      first.classList.add("active");
      first.querySelector(".accordion-content").style.maxHeight = '125px';
      first.querySelector(".accordion-content").style.overflowY = 'scroll';

      image.src = first.getAttribute("data-image");
      setTimeout(() => image.classList.add("fade-in"), 50);
    }
  }
</script>

<style lang="scss" scoped>
  @import '@/assets/styles/sokal-utility-classes.scss';
  @import '@/assets/styles/sokal-modern-styles.scss';
  @import '@/assets/styles/modern-utility-classes.scss';
  @import '@/assets/styles/sokal_utility_classes_responsive.scss';
</style>

<style scoped>
  #seo-content-accordion-component .seo-content-accordion {
    overflow-y: auto;
    color: var(--primary-dark);
  }

  #seo-content-accordion-component .seo-content-accordion .title-block-content .super-title {
    font-size: 1rem;
    color: var(--secondary-color);
  }

  #seo-content-accordion-component .seo-content-accordion .title-block-content .sub-title {
    font-size: 1.25rem;
  }

  #seo-content-accordion-component .seo-content-accordion .title-block-content h2 {
    font-size: 2.5rem;
  }

  #seo-content-accordion-component .accordion-item {
    border-left: 2px solid transparent;
  }

  #seo-content-accordion-component .accordion-item.active {
    border-color: var(--secondary-color);
  }

  #seo-content-accordion-component .accordion-header {
    width: 100%;
    padding: 15px;
    border: none;
    text-align: left;
    cursor: pointer;
    font-size: 1.75rem;
    font-weight: 600;
    color: var(--primary-dark);
    background-color: transparent;
  }

  #seo-content-accordion-component .accordion-content {
    max-height: 0;
    overflow: hidden;
    transition: max-height 0.3s ease;
    padding: 0 15px;
  }

  #seo-content-accordion-component .accordion-content .text-link {
    color: var(--secondary-color);
  }

  #seo-content-accordion-component .accordion-content p {
    font-size: 1.1rem;
  }

  #seo-content-accordion-component .accordion-content::-webkit-scrollbar {
    width: 12px;
  }

  #seo-content-accordion-component .accordion-content::-webkit-scrollbar-track {
    background: rgba(0,0,0,0.2);
    height: 100%;
    padding: 5px;
    border-radius: 10px;
  }

  #seo-content-accordion-component .accordion-content::-webkit-scrollbar-thumb {
    background-color: var(--primary-dark);
    border-radius: 10px;
    border: 2.5px solid transparent;
    background-clip: content-box;
  }

  #seo-content-accordion-component .image-area {
    width: 100%;
    height: 100%;
    padding: 10rem 0 5rem 2.5rem;
  }

  #seo-content-accordion-component .image-area img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 20px;
    opacity: 0;
    transition: opacity 0.5s ease;
  }

  #seo-content-accordion-component .fade-in {
    opacity: 1 !important;
  }
  .sokal-modern-styles .sokal-btn-primary.has-border-radius {
    border-radius: var(--brand-br);
  }

  @media (min-width: 992px) {
    #seo-content-accordion-component .seo-content-accordion {
      padding-right: 5rem;
    }
    #seo-content-accordion-component .sokal-md-grid {
      grid-template-columns: 1fr 1fr;
    }
    #seo-content-accordion-component .image-area {
      max-height: 650px;
    }
  }

  @media (max-width: 1199px) {
    #seo-content-accordion-component {
      padding-left: 3em;
      padding-right: 3em;
    }
  }

  @media (max-width: 991px) {
    #seo-content-accordion-component {
      padding-left: 2em;
      padding-right: 2em;
    }
    #seo-content-accordion-component .accordion-flex {
      display: flex;
      flex-direction: column-reverse;
    }
    #seo-content-accordion-component .image-area {
      padding-left: 0;
    }
  }

  @media (max-width: 767px) {
    #seo-content-accordion-component {
      padding-left: 1em;
      padding-right: 1em;
    }
  }

  @media (max-width: 575px) {
    #seo-content-accordion-component .cta-btn-block {
      flex-direction: column;
      float: left;
    }
  }
</style>